import { useQuery } from "@tanstack/react-query";
import { getCollections } from "../../api/apiCollections";
import i18next from "i18next";

/**
 * Hook to fetch filtered collections list
 * @param {Object} params - Query parameters (page, per_page, search, etc.)
 */
export function useGetCollections(params = {}) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["collections", params, i18next.language],
        queryFn: () => getCollections(params),
        retry: false,
    });

    const collections = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params.per_page || 15, total: 0 };

    return { isLoading, error, collections, meta, refetch };
}
